import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HelpCircle, MessageSquare } from 'lucide-react';
import LegalPageLayout from '../componnents/LegalPageLayout/LegalPageLayout';
import LegalSection from '../componnents/LegalPageLayout/LegalSection';
import LegalContactBlock from '../componnents/LegalPageLayout/LegalContactBlock';
import HowToAccordion from '../componnents/HowTo/HowToAccordion';

const HowTo = () => {
  const { t } = useTranslation('howto');

  return (
    <LegalPageLayout
      icon={HelpCircle}
      title={t('title')}
      subtitle={t('subtitle')}
      backLabel={t('backToHome')}
    >
      <LegalSection>
        <p>{t('intro')}</p>
      </LegalSection>

      <HowToAccordion />

      <LegalContactBlock
        title={t('help.title')}
        description={t('help.description')}
        action={
          <Link to="/feedback" className="legal-contact-btn">
            <MessageSquare size={18} />
            {t('help.cta')}
          </Link>
        }
      />
    </LegalPageLayout>
  );
};

export default HowTo;
